/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RadarOrderRequest = {
    strategy_version_id: string;
    code: string;
    entry_price_mode: RadarOrderRequest.entry_price_mode;
    manual_limit_price?: (number | null);
    tick_offset?: number;
    stop_loss_price: number;
    risk_exposure: number;
};
export namespace RadarOrderRequest {
    export enum entry_price_mode {
        LAST = 'last',
        ASK1PLUS_TICKS = 'ask1PlusTicks',
        MANUAL_LIMIT = 'manualLimit',
    }
}

